import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NoticeUiModule } from "@youm-front/notice/ui";
import { UtilsCommonModule } from "@youm-front/utils/common";
import Components from "./components";
import { NoticeFeatureNoticeService } from "./notice-feature-notice.service";

@NgModule({
  declarations: [...Components],
  imports: [CommonModule, NoticeUiModule, UtilsCommonModule],
  exports: [...Components],
  providers: [NoticeFeatureNoticeService]
})
export class NoticeFeatureNoticeModule {}
